import {
  SECONDS_MS,
} from '../constants/time.ts';

export enum EToastLife {
  SUCCESS = 3 * SECONDS_MS,
  WARNING = 5 * SECONDS_MS,
  ERROR = 10 * SECONDS_MS,
}

export const TOAST_LIFETIME_INFINITY = undefined;
